webpackJsonp([15943543102600],{

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(44);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(43);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(84);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(186);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: #32F095;\n  border: 0\n  border-radius: 50px\n  color: #121727\n  cursor: pointer\n  display: inline-flex\n    align-items: center\n  font-family: inherit\n  font-size: 1.375rem\n  font-weight: 700\n  letter-spacing: 0.1em\n  line-height: 1\n  margin: 0 auto 2.5rem;\n  padding: 1.25rem 2.5rem\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: all .35s ease;\n  :hover {\n    background: #fff\n  }\n  @media screen and (min-width: 1000px) {\n    & {\n      margin: 0 0 2.5rem;\n    }\n  }\n'], ['\n  background: #32F095;\n  border: 0\n  border-radius: 50px\n  color: #121727\n  cursor: pointer\n  display: inline-flex\n    align-items: center\n  font-family: inherit\n  font-size: 1.375rem\n  font-weight: 700\n  letter-spacing: 0.1em\n  line-height: 1\n  margin: 0 auto 2.5rem;\n  padding: 1.25rem 2.5rem\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: all .35s ease;\n  :hover {\n    background: #fff\n  }\n  @media screen and (min-width: 1000px) {\n    & {\n      margin: 0 0 2.5rem;\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styledComponents2.default.a(_templateObject);
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    border-bottom 1px solid rgba(255,255,255,.08);\n    border-radius: 4px;\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    margin: 2.5rem 0 5rem;\n    overflow: hidden;\n    p {\n        margin-bottom: 1rem;\n    }\n    @media screen and (min-width: 800px) {\n        & {\n            flex-direction: row;\n            align-items: flex-start;\n        }\n    }\n    span {\n      font-weight: 700;\n      letter-spacing: 0.1em;\n      text-transform: uppercase;\n    }\n}\n'], ['\n    border-bottom 1px solid rgba(255,255,255,.08);\n    border-radius: 4px;\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    margin: 2.5rem 0 5rem;\n    overflow: hidden;\n    p {\n        margin-bottom: 1rem;\n    }\n    @media screen and (min-width: 800px) {\n        & {\n            flex-direction: row;\n            align-items: flex-start;\n        }\n    }\n    span {\n      font-weight: 700;\n      letter-spacing: 0.1em;\n      text-transform: uppercase;\n    }\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  margin-bottom: 5rem;\n  width: 100%;\n  @media screen and (min-width: 800px) {\n    padding: 0 0 0 3rem;\n  }\n'], ['\n  flex: 1;\n  margin-bottom: 5rem;\n  width: 100%;\n  @media screen and (min-width: 800px) {\n    padding: 0 0 0 3rem;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background: #32f095;\n  border-radius: 4px;\n  margin: 0 0 1.5rem;\n  position: relative;\n  padding: 0;\n  img {\n    border-radius: 4px;\n    mix-blend-mode: multiply;\n    vertical-align: top;\n    max-width: 120px;\n    width: 100%;\n  }\n  @media screen and (min-width: 800px) {\n    & {\n      width: 200px;\n    }\n    img {\n      max-width: 200px;\n    }\n  }\n'], ['\n  background: #32f095;\n  border-radius: 4px;\n  margin: 0 0 1.5rem;\n  position: relative;\n  padding: 0;\n  img {\n    border-radius: 4px;\n    mix-blend-mode: multiply;\n    vertical-align: top;\n    max-width: 120px;\n    width: 100%;\n  }\n  @media screen and (min-width: 800px) {\n    & {\n      width: 200px;\n    }\n    img {\n      max-width: 200px;\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-size: 2.5rem;\n  font-weight: 300;\n  margin: 0;\n  @media screen and (min-width: 750px) {\n    &::before {\n      background: #32f095;\n      content: \'\';\n      display: block;\n      height: 4px;\n      margin-bottom: 2.5rem;\n      width: 40px;\n    }\n  }\n'], ['\n  font-size: 2.5rem;\n  font-weight: 300;\n  margin: 0;\n  @media screen and (min-width: 750px) {\n    &::before {\n      background: #32f095;\n      content: \'\';\n      display: block;\n      height: 4px;\n      margin-bottom: 2.5rem;\n      width: 40px;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-weight: bold;\n'], ['\n  font-weight: bold;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: 2rem;\n  font-weight: 300;\n  margin: 0;\n  &::before {\n    background: rgba(255, 255, 255, 0.08);\n    border-radius: 4px;\n    content: \'Talk:\';\n    display: block;\n    margin-bottom: 1.5rem;\n    margin-top: 3.5rem;\n    text-transform: uppercase;\n    font-size: 1rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    line-height: 1;\n    padding: 1rem;\n  }\n'], ['\n  font-size: 2rem;\n  font-weight: 300;\n  margin: 0;\n  &::before {\n    background: rgba(255, 255, 255, 0.08);\n    border-radius: 4px;\n    content: \'Talk:\';\n    display: block;\n    margin-bottom: 1.5rem;\n    margin-top: 3.5rem;\n    text-transform: uppercase;\n    font-size: 1rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    line-height: 1;\n    padding: 1rem;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  margin-right: 1.5rem;\n  display: block;\n  @media screen and (min-width: 600px) {\n    display: inline;\n  }\n'], ['\n  margin-right: 1.5rem;\n  display: block;\n  @media screen and (min-width: 600px) {\n    display: inline;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  margin-right: 1rem;\n  display: block;\n  @media screen and (min-width: 600px) {\n    display: inline;\n  }\n'], ['\n  margin-right: 1rem;\n  display: block;\n  @media screen and (min-width: 600px) {\n    display: inline;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(114);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Div = _styledComponents2.default.div(_templateObject2);
	
	var Figure = _styledComponents2.default.figure(_templateObject3);
	
	var Name = _styledComponents2.default.h3(_templateObject4);
	
	var Title = _styledComponents2.default.p(_templateObject5);
	
	var TalkTitle = _styledComponents2.default.h4(_templateObject6);
	
	var Bio = _styledComponents2.default.p(_templateObject7);
	
	var Talk = _styledComponents2.default.p(_templateObject7);
	
	var Twitter = _styledComponents2.default.a(_templateObject8);
	
	var Website = _styledComponents2.default.a(_templateObject9);
	
	var Speaker = function Speaker(_ref) {
	  var name = _ref.name,
	      title = _ref.title,
	      photo = _ref.photo,
	      photoTwo = _ref.photoTwo,
	      bio = _ref.bio,
	      twitter = _ref.twitter,
	      website = _ref.website,
	      talkTitle = _ref.talkTitle,
	      talkHTML = _ref.talkHTML,
	      shortSlug = _ref.shortSlug;
	  return _react2.default.createElement(
	    Container,
	    { id: shortSlug },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        Figure,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: photo, alt: name })
	      ),
	      photoTwo && _react2.default.createElement(
	        Figure,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: photoTwo, alt: name })
	      )
	    ),
	    _react2.default.createElement(
	      Div,
	      null,
	      _react2.default.createElement(
	        Name,
	        null,
	        name
	      ),
	      _react2.default.createElement(
	        Title,
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        Bio,
	        null,
	        bio
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          Twitter,
	          {
	            href: 'https://twitter.com/' + twitter,
	            onClick: function onClick() {
	              return gtag('event', shortSlug + '-twitter-link', {
	                event_category: 'link',
	                event_label: name + ' Twitter Link'
	              });
	            }
	          },
	          twitter
	        ),
	        _react2.default.createElement(
	          Website,
	          {
	            href: website,
	            onClick: function onClick() {
	              return gtag('event', shortSlug + '-website-link', {
	                event_category: 'link',
	                event_label: name + ' Website Link'
	              });
	            }
	          },
	          website
	        )
	      ),
	      _react2.default.createElement(
	        TalkTitle,
	        null,
	        talkTitle
	      ),
	      _react2.default.createElement(Talk, { dangerouslySetInnerHTML: { __html: talkHTML } })
	    )
	  );
	};
	
	exports.default = Speaker;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 1000px;\n  h2 {\n    margin-bottom: 5rem;\n  }\n  h2 + p,\n  .buy-tickets {\n    margin-bottom: 2.5rem;\n    text-align: center;\n  }\n  div:last-of-type {\n    border-bottom: 0;\n    margin-bottom: 2.5rem;\n  }\n'], ['\n  max-width: 1000px;\n  h2 {\n    margin-bottom: 5rem;\n  }\n  h2 + p,\n  .buy-tickets {\n    margin-bottom: 2.5rem;\n    text-align: center;\n  }\n  div:last-of-type {\n    border-bottom: 0;\n    margin-bottom: 2.5rem;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _buyticketsbutton = __webpack_require__(81);
	
	var _buyticketsbutton2 = _interopRequireDefault(_buyticketsbutton);
	
	var _speaker = __webpack_require__(238);
	
	var _speaker2 = _interopRequireDefault(_speaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject);
	
	var SpeakersPage = function (_React$Component) {
	  _inherits(SpeakersPage, _React$Component);
	
	  function SpeakersPage() {
	    _classCallCheck(this, SpeakersPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SpeakersPage.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Speakers'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          _buyticketsbutton2.default,
	          {
	            href: 'https://www.lifeway.com/en/product/digital-pass-faith-leads-tech-conference-P005815391',
	            target: '_blank',
	            onClick: function onClick() {
	              fbq('track', 'DigitalPass');
	              twq('track', 'DigitalPass');
	              gtag('event', 'buy-digital-pass-button', {
	                event_category: 'button',
	                event_label: 'Buy Digital Pass Speaker Page Top'
	              });
	            }
	          },
	          'Buy Conference Recordings - $35'
	        )
	      ),
	      data.allMarkdownRemark.edges.map(function (_ref, i) {
	        var node = _ref.node;
	
	        var shortSlug = node.fields.slug.split('/')[2];
	        return _react2.default.createElement(_speaker2.default, {
	          key: i,
	          name: node.frontmatter.name,
	          title: node.frontmatter.title,
	          photo: node.frontmatter.profilePic.childImageSharp.sizes,
	          photoTwo: node.frontmatter.profilePicTwo ? node.frontmatter.profilePicTwo.childImageSharp.sizes : null,
	          bio: node.frontmatter.bio,
	          twitter: node.frontmatter.twitter,
	          website: node.frontmatter.website,
	          talkTitle: node.frontmatter.talkTitle,
	          talkHTML: node.html,
	          shortSlug: shortSlug
	        });
	      }),
	      _react2.default.createElement(
	        'p',
	        { className: 'buy-tickets' },
	        _react2.default.createElement(
	          _buyticketsbutton2.default,
	          {
	            href: 'https://www.lifeway.com/en/product/digital-pass-faith-leads-tech-conference-P005815391',
	            target: '_blank',
	            onClick: function onClick() {
	              fbq('track', 'DigitalPass');
	              twq('track', 'DigitalPass');
	              gtag('event', 'buy-digital-pass-button', {
	                event_category: 'button',
	                event_label: 'Buy Digital Pass Speaker Page Bottom'
	              });
	            }
	          },
	          'Buy Conference Recordings - $35'
	        )
	      )
	    );
	  };
	
	  return SpeakersPage;
	}(_react2.default.Component);
	
	exports.default = SpeakersPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-js-f40229a40db07e48aef7.js